export default __webpack_public_path__ + "static/media/Gold_Medal.e63f1eeb.png";